// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__qqr8V","inputWrap":"styles_inputWrap__3UJF2","input":"styles_input__2-h5I"};